import {Component} from "react";
import React from "react";
import PropTypes from 'prop-types';
import PatientListItem from "./PatientListItem.jsx";
const I18n = require('react-redux-i18n').I18n;

export default class PatientSelectStep extends Component {

    constructor(props) {
        super(props);
        this.onEnter = this.onEnter.bind(this);
    }

    onEnter(e) {
        if (e.key === 'Enter' && this.props.selected) {
            this.props.goNext()
        }
    }

    componentDidMount() {
        document.addEventListener("keydown", this.onEnter)
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.onEnter)
    }

    render () {
        let patients = this.props.patients.map((p) => {
           return <PatientListItem key={p.globalId} patient={p} selected={this.props.selected && this.props.selected.globalId === p.globalId} onClick={(e) => this.props.selectPatient(p)}/>
        });

        return (
            <div>
                <div className="patient-lookup-lbl">
                    {I18n.t('Patient Lookup')}
                </div>
                <div className="patient-lookup-instr">
                    {I18n.t('selectStepInstructions')}
                </div>
                <div>
                    <div className="patient-lookup-table-titles">
                        <span>{I18n.t('First Name')}</span>
                        <span>{I18n.t('Last Name')}</span>
                    </div>
                    <div className="patients">
                        {patients}
                    </div>
                </div>
                <div className="patient-lookup-btn-conf-back">
                    <div className="bootstrap field">
                        <button className="btn btn-default patient-lookup-button-default" onClick={this.props.goBack}>{I18n.t('Back')}</button>
                        <button className="btn btn-primary patient-lookup-button-primary" disabled={!this.props.selected} onClick={this.props.goNext}>{I18n.t('Confirm')}</button>
                    </div>
                </div>
            </div>
        );
    }
}

PatientSelectStep.PropTypes = {
    patients: PropTypes.array,
    selected: PropTypes.object,
    selectPatient: PropTypes.func,
    goBack: PropTypes.func
};